// Local translations
export const T = {
  en_GB: {
    settings: "Settings",
    aiSettings: "AI Settings",
    pageDescription: "Configure AI models for chat, translations, and summaries.",
    loadFailed: "Failed to load AI models",
    systemModels: "System Models",
    customProviders: "Custom Providers",
    addProvider: "Add Provider",
    addProviderDescription:
      "Connect an external OpenAI-compatible API provider. You can add models after creating it.",
    noCustomProviders:
      "No custom providers. Add one to use models from OpenRouter, Azure, or other providers.",
    defaultModels: "Default Models",
    chatModel: "Chat Model (agent with tools)",
    simpleModel: "Simple Model (translations, summaries)",
    systemDefault: "System default",
    globalRoutingNote: "Routed via EU region but not EU-residency-guaranteed by upstream",
    enabled: "Enabled",
    deleteProvider: "Delete provider",
    testModel: "Test model",
    editModel: "Edit model",
    deleteModel: "Delete model",
    name: "Name",
    apiUrl: "API URL",
    apiKey: "API Key",
    namePlaceholder: "e.g. OpenRouter, Azure OpenAI",
    urlPlaceholder: "e.g. https://openrouter.ai/api/v1",
    keyPlaceholder: "sk-...",
    cancel: "Cancel",
    editModelTitle: "Edit Model",
    addModelTitle: "Add Model",
    editModelDescription: "Update the model configuration.",
    addModelDescription:
      "Add a model available from this provider. Use the model code expected by the API.",
    displayName: "Display Name",
    modelCode: "Model Code",
    displayNamePlaceholder: "e.g. GPT-4o, Claude Sonnet 4.6",
    modelCodePlaceholder: "e.g. openai/gpt-4o, anthropic/claude-sonnet-4.6",
    contextSize: "Context Size (K tokens)",
    inputPrice: "Input Price (€/M tokens)",
    outputPrice: "Output Price (€/M tokens)",
    costTrackingHint: "Optional — for cost tracking",
    save: "Save",
    addModel: "Add Model",
    sidebarAgents: "Sidebar Agents",
    aiAgentsLabel: "AI agents in sidebar",
    aiAgentsHint:
      "Show the chat, client agent, design agent, and scheduler tabs in the sidebar. When off, only Documentation and Ideas remain. Server-side translations, summaries, and file transcription are unaffected.",
    training: "Training",
    systemBadge: "System",
    model: "model",
    models: "models",
    allowTraining: "Allow training on chats",
    allowTrainingHint:
      "When enabled, your chats may be used to improve our agents — prompts, tools, and evaluations. Processing is performed in-house at Quantfolio HQ on local models.",
    pricingNote: "Model prices are shown in EUR (input/output per million tokens) and exclude VAT.",
    globalFootnotePre: "Routed through an EU region but classified as",
    globalFootnotePost:
      "by the upstream provider — data residency is not contractually guaranteed in the EU. Avoid for workloads with hard GDPR data-residency requirements.",
  },
  nb_NO: {
    settings: "Innstillinger",
    aiSettings: "AI-innstillinger",
    pageDescription: "Konfigurer AI-modeller for chat, oversettelser og sammendrag.",
    loadFailed: "Kunne ikke laste AI-modeller",
    systemModels: "Systemmodeller",
    customProviders: "Egendefinerte leverandører",
    addProvider: "Legg til leverandør",
    addProviderDescription:
      "Koble til en ekstern API-leverandør som er kompatibel med OpenAI. Du kan legge til modeller etter at den er opprettet.",
    noCustomProviders:
      "Ingen egendefinerte leverandører. Legg til én for å bruke modeller fra OpenRouter, Azure eller andre leverandører.",
    defaultModels: "Standardmodeller",
    chatModel: "Chat-modell (agent med verktøy)",
    simpleModel: "Enkel modell (oversettelser, sammendrag)",
    systemDefault: "Systemstandard",
    globalRoutingNote: "Rutes via EU-region, men ikke garantert EU-lagret av leverandøren",
    enabled: "Aktivert",
    deleteProvider: "Slett leverandør",
    testModel: "Test modell",
    editModel: "Rediger modell",
    deleteModel: "Slett modell",
    name: "Navn",
    apiUrl: "API-URL",
    apiKey: "API-nøkkel",
    namePlaceholder: "f.eks. OpenRouter, Azure OpenAI",
    urlPlaceholder: "f.eks. https://openrouter.ai/api/v1",
    keyPlaceholder: "sk-...",
    cancel: "Avbryt",
    editModelTitle: "Rediger modell",
    addModelTitle: "Legg til modell",
    editModelDescription: "Oppdater modellkonfigurasjonen.",
    addModelDescription:
      "Legg til en modell som er tilgjengelig fra denne leverandøren. Bruk modellkoden API-et forventer.",
    displayName: "Visningsnavn",
    modelCode: "Modellkode",
    displayNamePlaceholder: "f.eks. GPT-4o, Claude Sonnet 4.6",
    modelCodePlaceholder: "f.eks. openai/gpt-4o, anthropic/claude-sonnet-4.6",
    contextSize: "Kontekststørrelse (K tokens)",
    inputPrice: "Inngangspris (€/M tokens)",
    outputPrice: "Utgangspris (€/M tokens)",
    costTrackingHint: "Valgfritt — for kostnadssporing",
    save: "Lagre",
    addModel: "Legg til modell",
    sidebarAgents: "Sidepanel-agenter",
    aiAgentsLabel: "AI-agenter i sidepanelet",
    aiAgentsHint:
      "Vis fanene for chat, klientagent, designagent og planlegger i sidepanelet. Når den er av, står bare Dokumentasjon og Ideer igjen. Oversettelser, sammendrag og filtranskripsjon på serversiden påvirkes ikke.",
    training: "Trening",
    systemBadge: "System",
    model: "modell",
    models: "modeller",
    allowTraining: "Tillat trening på chatter",
    allowTrainingHint:
      "Når dette er på, kan chattene dine brukes til å forbedre agentene våre — instruksjoner, verktøy og evalueringer. Behandlingen skjer internt hos Quantfolio på lokale modeller.",
    pricingNote: "Modellpriser vises i EUR (inn/ut per million tokens) og er uten mva.",
    globalFootnotePre: "Rutes gjennom en EU-region, men er klassifisert som",
    globalFootnotePost:
      "av leverandøren — datalagring i EU er ikke kontraktsfestet. Unngå for arbeid med strenge GDPR-krav til datalagring.",
  },
} as const;
